import { styled } from 'linaria/react';

export const FrontendCofigurationChexboxesWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  margin-top: var(--space-300);
`;
export const CheckboxItemWrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--space-200);
`;
